module.exports = __webpack_public_path__ + "img/tea-t.d40dbc5a.png";